import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { RentaPensionesPensionadoModalComponent } from '../modales/renta-pensiones/renta-pensiones-pensionado-modal/renta-pensiones-pensionado-modal.component';
import { RentaPensionesSobrevivienteExteriorModalComponent } from '../modales/renta-pensiones/renta-pensiones-sobreviviente-modal/renta-pensiones-sobreviviente-modal.component';
import { RentaPensionesIndemnizacionDisponibleModalComponent } from '../modales/renta-pensiones/renta-pensiones-indemnizacion-modal/renta-pensiones-indemnizacion-modal.component';
import { RentaPensionesExteriorModalComponent } from '../modales/renta-pensiones/renta-pensiones-exterior-modal/renta-pensiones-exterior-modal.component';
import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { MessageObservableService } from '../../../../services/message-observable.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo

const questions:Question[] = [
  {question: '¿Recibió ingresos de pensiones de jubilación, vejez o invalidez? ', field: 'cs_id_717', show:true, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: '¿Recibió pensión en sobrevivientes o riesgos laborales de Colombia?', field: 'cs_id_722', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: '¿Usted recibió indemnización sustitutiva de pensión o devolución de ahorro pensional?', field: 'cs_id_727', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: '¿Recibió pensiones del exterior?', field: 'cs_id_732', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"}
];

@Component({
  selector: 'app-renta-pensiones',
  templateUrl: './renta-pensiones.component.html',
  styleUrls: ['./renta-pensiones.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class RentaPensionesComponent extends HandlerComponent implements OnInit {

  @Input('model') model: DDocumento = new DDocumento();
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _messagesObs: MessageObservableService

  ) { 
    super(questions);
  }

  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);    this.validateComponentCompleted();
  }

  validateQuestions(id: number) {
    console.log(id);

  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
     /*  if (res.operation === 'model2100Completed'){
        this.initilizeQuestionsDesdeModelo(res.message);
        this.validateComponentCompleted();
      } */
    });
  }

  initilizeQuestionsDesdeModelo(model){
    for(let i=0; i<questions.length; i++){
      switch(i){
        case 0:
        questions[i].resp = model.doc.cuerpo.cs_id_717;  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_717 != undefined && model.doc.cuerpo.cs_id_717 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_717 == "1"){questions[i].show = true}
          break;
        case 1:
        questions[i].resp = model.doc.cuerpo.cs_id_722;  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_722 != undefined && model.doc.cuerpo.cs_id_722 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_722 == "1"){questions[i].show = true}
          break;
        case 2:
        questions[i].resp = model.doc.cuerpo.cs_id_727;  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_727 != undefined && model.doc.cuerpo.cs_id_727 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_727 == "1"){questions[i].show = true}
          break;
        case 3:
        questions[i].resp = model.doc.cuerpo.cs_id_732;  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_732 != undefined && model.doc.cuerpo.cs_id_732 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_732 == "1"){questions[i].show = true}
          break;
      }
      this.checkNextQuestion(i);
    }
    
  }

  openModal(indexQuestionModal:number) {
    const config = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    switch (indexQuestionModal) {
      case 0:
        let dialog0 = this.dialog.open(RentaPensionesPensionadoModalComponent, config);
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 1:
        let dialog1 = this.dialog.open(RentaPensionesSobrevivienteExteriorModalComponent, config);
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 2:
        let dialog2 = this.dialog.open(RentaPensionesIndemnizacionDisponibleModalComponent, config);
        dialog2.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog2.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;  
      case 3:
        let dialog3 = this.dialog.open(RentaPensionesExteriorModalComponent, config);
        dialog3.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog3.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
    }
    
    
  }

  protected validateModalCompleted(indexQuestion:number):boolean{
    let isModalComplete:boolean = false;
    switch(indexQuestion){
      case 0://Modal 1
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_955, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 1://Modal 2
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_956, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 2://Modal 3
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_957, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 3://Modal 4
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_958, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      default:
        break;
    }
    if(isModalComplete){
      questions[indexQuestion].isCompleted = true;
      if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    }else{
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }
  
  protected validateHasModalValues(indexQuestion:number):boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){
      case 0://Modal 1
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_718, "0")){
          hasValues=true;break;
        }
       /*  if(this.model.doc.cuerpo.cs_id_152=="1"){
          hasValues=true;break;
        } */
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_719, "0")){
          hasValues=true;break;
        }

        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_720, "0")){
          hasValues=true;break;
        }
        break;
      case 1://Modal 2
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_723, "0")){
          hasValues=true;break;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_724, "0")){
          hasValues=true;break;
        }

        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_725, "0")){
          hasValues=true;break;
        }
        break;
      case 2://Modal 3
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_728, "0")){
          hasValues=true;break;
        }
        
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_729, "0")){
          hasValues=true;break;
        }
        
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_730, "0")){
          hasValues=true;break;
        }
        break;
      case 3://Modal 4
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_734, "0") || 
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_735, "0") ||
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_661, "0") ||
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_736, "0") ||
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_738, "0") || 
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_739, "0") ||
        this.model.doc.cuerpo.cs_id_733 ||  this.model.doc.cuerpo.cs_id_737 ){
          hasValues=true;break;
        }
       
        break;
      default:
        return false;
    }
    return hasValues;
  }
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      case 0:
        this.model.doc.cuerpo.cs_id_718="0";
        this.model.doc.cuerpo.cs_id_719="0";
        this.model.doc.cuerpo.cs_id_720="0";
        this.model.doc.cuerpo.cs_id_721="0";
        this.model.doc.cuerpo.cs_id_955="0";//Indicador de Completo
        break;
      case 1:
        this.model.doc.cuerpo.cs_id_723="0";
        this.model.doc.cuerpo.cs_id_724="0";
        this.model.doc.cuerpo.cs_id_725="0";
        this.model.doc.cuerpo.cs_id_726="0";
        this.model.doc.cuerpo.cs_id_956="0";//Indicador de Completo
        break;
      case 2:
        this.model.doc.cuerpo.cs_id_728="0";
        this.model.doc.cuerpo.cs_id_729="0";
        this.model.doc.cuerpo.cs_id_730="0";
        this.model.doc.cuerpo.cs_id_731="0";
        this.model.doc.cuerpo.cs_id_957="0";//Indicador de Completo
        break;  
      case 3:
        this.model.doc.cuerpo.cs_id_734="0"; 
        this.model.doc.cuerpo.cs_id_735="0";
        this.model.doc.cuerpo.cs_id_661="0";
        this.model.doc.cuerpo.cs_id_736="0";
        this.model.doc.cuerpo.cs_id_738="0"; 
        this.model.doc.cuerpo.cs_id_739="0";
        this.model.doc.cuerpo.cs_id_733=null;  
        this.model.doc.cuerpo.cs_id_737=null;
        this.model.doc.cuerpo.cs_id_654="0";
        this.model.doc.cuerpo.cs_id_313="0";
        this.model.doc.cuerpo.cs_id_655="0";
        this.model.doc.cuerpo.cs_id_740="0";
        this.model.doc.cuerpo.cs_id_958="0";//Indicador de Completo
        break;
    }
  }

  public validateComponentCompleted(): boolean{
    for(let i=0; i < questions.length; i++){
      if(questions[i].isCompleted==false){
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if(this.model.doc.cuerpo[data.field] == "0"){
      if(this.validateHasModalValues(index)){
        this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
          if (result) {
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateComponentCompleted();
            this.saveModel.emit(true);
          }else{
            this.model.doc.cuerpo[data.field] == "";
          }
        });
      }else{
        questions[index].isCompleted = true;
        this.cleanModalValues(index);
        this.saveModel.emit(true);
      }
    }else if (this.model.doc.cuerpo[data.field] == "1"){
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrandolo completo
      this.openModal(index);
      this.saveModel.emit(true);
      
    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
    console.log(data);
    console.log(this.model);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/renta-pensiones/renta-pensiones.component.ts